import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiCheckCircle } = FiIcons;

const items = [
  {
    wrong: "ดวงกับการลงทุน มันคนละเรื่องกัน ใช้จริงไม่ได้หรอก",
    right: "นักธุรกิจและนักลงทุนระดับหมื่นล้านจำนวนมาก ใช้ปาจื้อควบคู่กับการวางแผนการเงินอย่างจริงจัง เพียงแต่ไม่มีใครพูดถึงในที่สาธารณะ เพราะกลัวถูกมองว่างมงาย"
  },
  {
    wrong: "ฉันไม่มีพื้นฐานโหราศาสตร์จีนเลย เรียนไม่ทันหรอก",
    right: "หลักสูตรนี้ออกแบบให้มือใหม่เข้าใจได้ภายในครึ่งวันแรก เพราะทุกอย่างคำนวณผ่านซอฟต์แวร์ให้อัตโนมัติ คุณแค่ต้องรู้ว่า 'ผลลัพธ์' หมายความว่าอย่างไรกับเงินในกระเป๋า"
  },
  {
    wrong: "รอให้มีเงินก้อนก่อน ค่อยมาวางแผนการลงทุนทีหลัง",
    right: "ยิ่งรู้ 'จังหวะดวงจร' ของตัวเองเร็วเท่าไหร่ คุณยิ่งวางแผน 10 ปีข้างหน้าได้แม่นยำขึ้น คนที่รอ คือคนที่เสียเวลาที่ดีที่สุดของดวงตัวเองไปฟรีๆ"
  }
];

export default function Misconceptions() {
  return (
    <section id="painpoints" className="section-padding bg-zinc-50 border-y border-zinc-200">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-brand-red font-bold uppercase tracking-widest text-xs mb-3 block">Agitate Section</span>
          <h2 className="text-3xl md:text-5xl font-black text-zinc-900 mb-6 uppercase">คุณเคยเชื่อแบบนี้อยู่ไหม?</h2>
          <p className="text-lg text-zinc-500 max-w-2xl mx-auto">ความเชื่อ 3 ข้อนี้ คือสิ่งที่ทำให้คนเก่งจำนวนมาก พลาดโอกาสทางการเงินที่ควรจะเป็นของเขา</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white p-8 border-b-4 border-brand-red shadow-sm group hover:shadow-xl transition-all"
            >
              <div className="mb-6">
                <div className="flex items-center gap-2 text-zinc-400 mb-3 text-xs font-bold uppercase tracking-tighter">
                  <SafeIcon icon={FiAlertCircle} className="w-4 h-4 text-zinc-300" />
                  Myth / ความเชื่อเดิม
                </div>
                <p className="text-lg text-zinc-500 font-medium leading-relaxed">{item.wrong}</p>
              </div>
              
              <div className="pt-6 border-t border-zinc-100">
                <div className="flex items-center gap-2 text-brand-red mb-3 text-xs font-bold uppercase tracking-tighter">
                  <SafeIcon icon={FiCheckCircle} className="w-4 h-4" />
                  Fact / ความจริง
                </div>
                <p className="text-zinc-900 font-bold leading-relaxed">{item.right}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}